import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";
import invoiceCancellation from "@/views/my-services/invoice-cancellation/invoice-cancellation.vue";

const invoiceRoutes = {
    LIST_INVOICES_BY_COMPANY_AND_DEVICE: "dashboard/billing/invoice/listByCompanyAndDevices",
    INVOICE_CANCELLATION: "dashboard/billing/invoice/cancel"
}
export default {
    listInvoiceByCompanyAndDevices(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(invoiceRoutes.LIST_INVOICES_BY_COMPANY_AND_DEVICE, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron facturas de esta compañia");
                        newData = data;
                        return;
                    }
                    if (code <= 0) {
                        toast.error(data.message);
                        newData = data;
                        return;
                    }
                    newData = data;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    invoiceCancellation(invoiceList,objData) {
        return new Promise(resolve => {
            let code = -1;
            let newData = {};
            http.post(invoiceRoutes.INVOICE_CANCELLATION, invoiceList, {params: objData})
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se han anulado correctamente");
                        newData = data;
                        return;
                    }
                    toast.error(data.message);
                    newData = data;
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }
}